export const colors = {
  blue1: '#3F8CFF', // button blue
  blue2: '#2BC5B4', // selected blue
  blue3: '#3F8C99', // background blue
  black1: '#26282E', // screen background
  black2: '#2D2F36', // cards background
  black3: '#383D48', // radio buttons
  black4: '#1F2127', // input box background
  gray: '#707070', // disabled text
  light: '#A9A9A9', // light text
  orange: '#C5502B',
  white: '#F6F6F6', // use this for most of the whites
  yellow: '#FFB23F',
};
